import { createSelector, createSlice } from "@reduxjs/toolkit";
import service from "../service";
import { reset } from "./globalActions";
import { generateClient } from 'aws-amplify/api';
import { sessionByLocationId } from "../graphql/customQueries";

const client = generateClient();

const moduleName = "location";

const initialState = {
    loading: false,
    items: [],
    sessions: [],
    active: null,
    nextToken: null,
};

const locationSlice = createSlice({
    name: moduleName,
    initialState,
    extraReducers: (builder) => {
        builder.addCase(reset, () => initialState);
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setLocations: (state, action) => {
            state.items = action.payload.items;
            state.nextToken = action.payload.nextToken;
        },
        setActive: (state, action) => {
            state.active = action.payload;
        },
        onLocationUpdated: (state, action) => {
            let idx = state.items.findIndex((l) => l.id === action.payload.id);
            state.items[idx] = action.payload;
        },
        setSessions: (state, action) => {
            state.sessions = action.payload;
        }
    },
});

export const { setLoading, setLocations, setActive, onLocationUpdated, setSessions } = locationSlice.actions;
export default locationSlice.reducer;

export const selectState = (state) => state[moduleName];
export const selectLoading = createSelector(selectState, (state) => state.loading);
export const selectLocations = createSelector(selectState, (state) => state.items);
export const selectActive = createSelector(selectState, (state) => state.active);
export const selectLocationById = createSelector([selectLocations, (state, id) => id], (locations, id) => locations.find((report) => report.id === id));
export const selectActiveLocation = createSelector([selectLocations, selectActive], (locations, active) => locations.find((l) => l.id === active));
export const selectSessions = createSelector(selectState, (state) => state.sessions);

export const fetchLocations = async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const locations = await service.listLocations();
        dispatch(setLocations(locations));
    } finally {
        dispatch(setLoading(false));
    }
};

export const modifyLocation = (newLocation) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const updatedLocation = await service.updateLocation(newLocation);
        dispatch(onLocationUpdated(updatedLocation));
        return updatedLocation;
    } finally {
        dispatch(setLoading(false));
    }
};

export const fetchSessions = (locationId) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const { data } = await client.graphql({
            query: sessionByLocationId,
            variables: {
                locationId,
                sortDirection: 'DESC',
                limit: 3,
            }
        })
        dispatch(setSessions(data.sessionByLocationId.items))
    } finally {
        dispatch(setLoading(false));
    }
}